import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Input from '../common/Input';
import Button from '../common/Button';
import { validateForm } from '../../utils/validators';
import './GrowerForm.css';

const VALIDATION_RULES = {
  name: { required: true, maxLength: 255 },
};

const INITIAL_FORM = {
  name: '',
  description: '',
};

const GrainVarietyForm = ({ variety, onSave, onCancel, isSaving }) => {
  const [form, setForm] = useState(INITIAL_FORM);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (variety) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setForm({
        name: variety.name || '',
        description: variety.description || '',
      });
    } else {
      setForm(INITIAL_FORM);
    }
  }, [variety]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next[name];
        return next;
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { isValid, errors: validationErrors } = validateForm(form, VALIDATION_RULES);
    if (!isValid) {
      const flat = {};
      Object.entries(validationErrors).forEach(([k, v]) => {
        flat[k] = Array.isArray(v) ? v[0] : v;
      });
      setErrors(flat);
      return;
    }
    onSave({ name: form.name.trim(), description: form.description.trim() });
  };

  return (
    <form className="grower-form" onSubmit={handleSubmit} noValidate>
      <fieldset className="grower-form__fieldset">
        <legend className="grower-form__legend">Grain Variety</legend>
        <div className="grower-form__row">
          <Input
            label="Name"
            name="name"
            value={form.name}
            onChange={handleChange}
            error={errors.name}
            required
            placeholder="e.g., Turkey Red Wheat"
          />
        </div>
        <div className="grower-form__row grower-form__row--full">
          <div className="input-wrapper">
            <label htmlFor="variety-description" className="input-label">Description</label>
            <textarea
              id="variety-description"
              name="description"
              value={form.description}
              onChange={handleChange}
              className="input grower-form__textarea"
              rows={3}
              placeholder="Origin, characteristics, typical uses..."
            />
          </div>
        </div>
      </fieldset>

      <div className="grower-form__actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isSaving}>
          Cancel
        </Button>
        <Button type="submit" variant="primary" disabled={isSaving}>
          {isSaving ? 'Saving...' : variety ? 'Save Changes' : 'Create Variety'}
        </Button>
      </div>
    </form>
  );
};

GrainVarietyForm.propTypes = {
  variety: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};

export default GrainVarietyForm;
